module.exports = {"attributes":{"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M17.3824 3.82388C17.3824 3.63667 17.3079 3.45683 17.1756 3.32445C17.0432 3.19207 16.8633 3.11765 16.6761 3.11765H4.32387C4.13666 3.11765 3.95683 3.19207 3.82445 3.32445C3.69207 3.45683 3.61765 3.63667 3.61765 3.82388V15.3851L5.33927 13.6635L5.41682 13.5932C5.60522 13.4387 5.8421 13.3534 6.08789 13.3533H16.6761C16.8633 13.3533 17.0432 13.2788 17.1756 13.1465C17.3079 13.0141 17.3824 12.8343 17.3824 12.6471V3.82388ZM19.5 12.6471C19.5 13.3959 19.2023 14.1142 18.6728 14.6437C18.1433 15.1732 17.4249 15.471 16.6761 15.471H6.52631L3.30744 18.6898C3.00462 18.9926 2.54915 19.0833 2.15349 18.9194C1.75791 18.7555 1.5 18.3694 1.5 17.9412V3.82388C1.5 3.07503 1.79769 2.35672 2.32721 1.82721C2.85672 1.29769 3.57503 1 4.32387 1H16.6761C17.425 1 18.1433 1.29769 18.6728 1.82721C19.2023 2.35672 19.5 3.07503 19.5 3.82388V12.6471Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
